module.exports = __webpack_public_path__ + "static/media/bg-image-33.59204cb8.jpg";